export const volleyballs = [
  {
   title: "Nivia Volleyball Merger",
    desc: "PU Soft Leather, Size 4 (18 P) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/VB-484_L.jpg",
    currency: "INR ",
    price: "725",
    mrp: "515.50",
    discount: "29% off",
  },
  {
   title: "Cosco Acclaim Volleyball",
    desc: "Cosco Acclaim Volleyball: P.U.Leather pasted, Multi-colour, size-4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CSVLBLACL.jpg",
    currency: "INR ",
    price: "690",
    mrp: "537.70",
    discount: "22% off",
  },
  {
   title: "Cosco Super Volley Volleyball",
    desc: "Cosco Super Volley Volleyball: Leather Pasted, Size-4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CSVLBLSPL.jpg",
    currency: "INR ",
    price: "1075",
    mrp: "837.90",
    discount: "22% off",
  },
 
  {
   title: "Slazenger V-500 Icon Volleyball (Size 4)",
    desc: "Slazenger V-500 Icon Volleyball, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYV500L.jpg",
    currency: "INR ",
    price: "1295",
    mrp: "1099",
    discount: "15% off",
  },
  {
   title: "Slazenger Beach Crazy Volleyball (Size 4)",
    desc: "Slazenger Beach Crazy Volleyball: Official Size and Weight, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYBCL.jpg",
    currency: "INR ",
    price: "474",
    mrp: "427",
    discount: "10% off",
  },
  {
   title: "Slazenger Smash Volleyball (Size 4)",
    desc: "Slazenger Smash Volleyball: Official Size and Weight, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYSML.jpg",
    currency: "INR ",
    price: "474",
    mrp: "427",
    discount: "10% off",
  },
  
  {
   title: "Nivia Volleyball Merger",
    desc: "PU Soft Leather, Size 4 (18 P) ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/VB-484_L.jpg",
    currency: "INR ",
    price: "725",
    mrp: "515.50",
    discount: "29% off",
  },
  {
   title: "Cosco Acclaim Volleyball",
    desc: "Cosco Acclaim Volleyball: P.U.Leather pasted, Multi-colour, size-4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CSVLBLACL.jpg",
    currency: "INR ",
    price: "690",
    mrp: "537.70",
    discount: "22% off",
  },
  {
   title: "Cosco Super Volley Volleyball",
    desc: "Cosco Super Volley Volleyball: Leather Pasted, Size-4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/CSVLBLSPL.jpg",
    currency: "INR ",
    price: "1075",
    mrp: "837.90",
    discount: "22% off",
  },
 
  {
   title: "Slazenger V-500 Icon Volleyball (Size 4)",
    desc: "Slazenger V-500 Icon Volleyball, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYV500L.jpg",
    currency: "INR ",
    price: "1295",
    mrp: "1099",
    discount: "15% off",
  },
  {
   title: "Slazenger Beach Crazy Volleyball (Size 4)",
    desc: "Slazenger Beach Crazy Volleyball: Official Size and Weight, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYBCL.jpg",
    currency: "INR ",
    price: "474",
    mrp: "427",
    discount: "10% off",
  },
  {
   title: "Slazenger Smash Volleyball (Size 4)",
    desc: "Slazenger Smash Volleyball: Official Size and Weight, Size 4 ",
    img: "https://storage.sg.content-cdn.io/cdn-cgi/image/width=500,height=500,quality=75,format=auto,fit=cover,g=top/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/SLZVLYSML.jpg",
    currency: "INR ",
    price: "474",
    mrp: "427",
    discount: "10% off",
  },
 
];
